import React from "react";

/**
 * SuiteBadge — badge di stato uniforme.
 *
 * tone:
 *  - ok       : verde (approvato, ok, positivo)
 *  - warn     : ambra (attenzione, sospeso)
 *  - err      : rosso (respinto, errore)
 *  - info     : blu acciaio (informativo neutrale)
 *  - neutral  : grigio caldo (default, disattivo)
 *  - brand    : verde petrolio (identità Suite)
 */
export function SuiteBadge({ children, tone = "neutral", size = "md", className = "", ...rest }) {
  const toneMap = {
    ok:      "bg-suite-accent-light text-suite-accent-hover border-suite-accent-border",
    warn:    "bg-suite-warning-light text-suite-warning border-suite-warning-border",
    err:     "bg-suite-error-light text-suite-error border-suite-error-border",
    info:    "bg-suite-secondary-light text-suite-secondary border-suite-secondary-border",
    neutral: "bg-suite-neutral-100 text-suite-neutral-600 border-suite-neutral-200",
    brand:   "bg-suite-primary-light text-suite-primary border-suite-primary-border",
  };
  const sizeMap = {
    sm: "text-[10px] px-1.5 py-0.5",
    md: "text-xs px-2 py-0.5",
    lg: "text-sm px-2.5 py-1",
  };
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-md border font-semibold ${toneMap[tone] || toneMap.neutral} ${sizeMap[size] || sizeMap.md} ${className}`}
      {...rest}
    >
      {children}
    </span>
  );
}

export default SuiteBadge;
